import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Icon } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { useMatch } from 'react-router-dom';
import { AppLink } from 'components/appLink';
import { useBreakpointValue } from 'utils/mediaQuery';
import { ContactsDetails } from './components/details/contactsDetails';
import { ContactsSidebar } from './components/sidebar/contactsSidebar';
import styles from './contacts.module.scss';
export const ContactsView = ({ list, details }) => {
    const companyMatch = useMatch('/contacts/company/:id');
    const userMatch = useMatch('/contacts/user/:id');
    const hasItemSelected = !!userMatch || !!companyMatch;
    const shouldShowBackButton = useBreakpointValue([
        hasItemSelected,
        null,
        false,
    ]);
    const rootClass = classNames({
        [styles.rootHasItemSelected]: hasItemSelected,
    }, styles.root);
    return (_jsxs(FlexBox, Object.assign({ height: "100%", background: "#fff", className: rootClass }, { children: [_jsx(Box, Object.assign({ className: styles.listPane }, { children: _jsx(ContactsSidebar, { children: list }) })), _jsxs(Box, Object.assign({ className: styles.viewPane }, { children: [shouldShowBackButton && (_jsx(Box, Object.assign({ padding: "0 400", className: styles.viewPaneTop }, { children: _jsxs(AppLink, Object.assign({ path: `/contacts/${companyMatch ? 'company' : 'user'}`, className: styles.backLink }, { children: [_jsx(Icon, { name: "angle-left", size: 24 }), ' ', _jsxs(Box, { children: ["Back to ", companyMatch ? 'companies' : 'contacts'] })] })) }))), _jsx(FlexBox, Object.assign({ flex: "1", className: styles.viewPaneBody, alignItems: "center" }, { children: details && _jsx(ContactsDetails, { children: details }) }))] }))] })));
};
